import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function Privacy() {
  return (
    <div className="flex flex-col min-h-screen font-sans bg-slate-50 text-slate-800">
      <Header />
      
      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-4xl font-extrabold mb-2 text-blue-900">Politique de Confidentialité</h1>
        <p className="text-slate-500 mb-8">Dernière mise à jour : 4 janvier 2026</p>

        <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-200 space-y-6">
            
            <section>
                <h2 className="text-xl font-bold mb-3 text-blue-800">1. Préambule et Loi 25</h2>
                <p>
                    <strong>FORFEO INC.</strong> (« nous ») s'engage à protéger la vie privée de ses utilisateurs conformément à la 
                    <em>Loi sur la protection des renseignements personnels dans le secteur privé</em> (Loi 25) du Québec. 
                    Cette politique détaille comment nous collectons, utilisons et protégeons vos données sur <strong>Forfeo Explore Québec</strong>.
                </p>
            </section>

            <section>
                <h2 className="text-xl font-bold mb-3 text-blue-800">2. Responsable de la protection des renseignements personnels</h2>
                <p>Conformément à la loi, voici les coordonnées du responsable désigné :</p>
                <div className="mt-2 p-4 bg-slate-50 rounded-lg border border-slate-200">
                    <p><strong>Responsable de la conformité</strong></p>
                    <p>FORFEO INC.</p>
                    <p>Courriel : <a href="mailto:privacy@forfeo.com" className="text-blue-600 underline">privacy@forfeo.com</a></p>
                    <p>Adresse : Québec, QC, Canada</p>
                </div>
            </section>

            <section>
                <h2 className="text-xl font-bold mb-3 text-blue-800">3. Collecte des données</h2>
                <ul className="list-disc pl-5 space-y-2">
                    <li><strong>Géolocalisation :</strong> Nous utilisons votre position (latitude/longitude) uniquement pour vous suggérer des activités à proximité. Cette donnée est traitée en temps réel et n'est pas stockée sur nos serveurs de manière permanente.</li>
                    <li><strong>Interactions IA :</strong> Les requêtes que vous envoyez à notre Assistant IA sont traitées par OpenAI (notre fournisseur) mais sont anonymisées autant que possible.</li>
                    <li><strong>Formulaires :</strong> Si vous remplissez le formulaire « Inscrire mon entreprise », nous collectons le nom de l'entreprise et vos coordonnées d'affaires.</li>
                </ul>
            </section>

            <section>
                <h2 className="text-xl font-bold mb-3 text-blue-800">4. Témoins (Cookies) et Google Maps</h2>
                <p>
                    Nous utilisons des services tiers comme Google Maps et Google Autocomplete. Ces services peuvent déposer des témoins pour fonctionner. 
                    En utilisant la carte interactive, vous acceptez les conditions de Google.
                </p>
            </section>

            <section>
                <h2 className="text-xl font-bold mb-3 text-blue-800">5. Vos droits</h2>
                <p>Vous disposez des droits suivants concernant vos renseignements personnels :</p>
                <ul className="list-disc pl-5 mt-2 space-y-1">
                    <li>Droit d’accès et de rectification.</li>
                    <li>Droit de retirer votre consentement à tout moment.</li>
                    <li>Droit à la désindexation (droit à l'oubli).</li>
                </ul>
                <p className="mt-2">Pour exercer ces droits, contactez notre responsable à l'adresse ci-dessus.</p>
            </section>

        </div>
      </main>

      <Footer />
    </div>
  );
}
